<template>
	<div>
		<div class="pc_top" id="navbar">
		  
		  <!--head-->
		  <div class="head">
		    <div class="logo"><a href="/"><img src="@/assets/images/logo.png"/></a></div>
		    
		    <!--menu-->
		    
		    <ul id="nav">
		      <li class="mainlevel" ><a href="javascript:void(0)" @click="go('/')" :class="sel==1?'cur':''">网站首页</a> </li>
		      <li class="mainlevel"><a href="javascript:void(0)" @click="go('/solutionList')" :class="sel==2?'cur':''">解决方案</a>
		       
		      </li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==3?'cur':''" @click="go('/caseList')">案例推荐</a>
		       
		      </li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==4?'cur':''" @click="go('/newList')">公司新闻</a></li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==5?'cur':''" @click="go('/about')" >关于数码人</a></li>
			  <li class="mainlevel"><a href="javascript:void(0)" :class="sel==6?'cur':''" @click="go('/join')">加入我们</a></li>
		      <li class="mainlevel"><a href="javascript:void(0)" :class="sel==7?'cur':''" @click="go('/contact')">联系我们</a></li>
		      <div class="clear"> </div>
		    </ul>
		    
		    <!--menu-->
		    
		    <div class="clear"></div>
		  </div>
		  <!--head--> 
		  
		</div>
		<!--shoujitop-->
		<div class="shouji_top">
		  <header :class="['cd-main-header',showPhone?'nav-is-visible':'']"> <a class="cd-logo" href="javascript:void(0)"><img style="width: 105px;" src="@/assets/images/logo.png"  width="180" alt="Logo"></a>
		    <ul class="cd-header-buttons">
		      <li><a :class="['cd-nav-trigger',showPhone?'nav-is-visible':'']" @click="changePhone"><span></span></a></li>
		    </ul>
		    <!-- cd-header-buttons --> 
		  </header>
		  <nav class="cd-nav">
		    <ul id="cd-primary-nav" :class="['cd-primary-nav is-fixed',showPhone?'nav-is-visible':'']">
				 <li><a href="javascript:void(0)" @click="go('/')">网站首页</a></li>
          <li><a href="javascript:void(0)" @click="go('/solutionList')">解决方案</a> </li>
          <li><a href="javascript:void(0)" @click="go('/caseList')">案例推荐</a></li>
          <li><a href="javascript:void(0)" @click="go('/newList')">公司新闻</a></li>
          <li><a href="javascript:void(0)" @click="go('/about')">关于数码人</a></li>
          <li><a href="javascript:void(0)" @click="go('/join')">加入我们</a></li>
          <li><a href="javascript:void(0)" @click="go('/contact')">联系我们</a></li>
		     
		    </ul>
		    <!-- primary-nav --> 
		  </nav>
		  <!-- cd-nav --> 
		  
		</div>
		<!--shoujitop-->
		</div>
</template>

<script>
	export default {
		components: {},
		props: {
			
			sel:{
				type: Number,
				default:1
			}
		 
		},
		data() {
			return {
				showPhone:false,
				token:''
			}
		},
		computed: {

		},
		mounted() {
			
			//this.token=window.sessionStorage.getItem('token')
			this.handleScroll()
		},
		methods: {
			handleScroll() {
			const navbar = document.getElementById('navbar');
			window.addEventListener('scroll', () => {
				if (window.scrollY > 50) {
					navbar.classList.add('scrolled');
				} else {
					navbar.classList.remove('scrolled');
				}
			});
		},
			changePhone(){
				this.showPhone=!this.showPhone
				this.$emit('changePhone',this.showPhone)
			},
			changeTag(item){
				this.selTag=item
			},
			
			go(url){
				if(this.$route.fullPath!=url){
					this.$router.push(url)
					this.$router.go(0)
				}
			}
		}
	}
</script>

